// (bnikom) code based off of https://github.com/emilebres/react-virtualized-checkbox
// differs from ./VirtualizedCheckbox in that this is a functional component

/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import AutoSizer from 'react-virtualized-auto-sizer';

import CheckboxesNoClass from './CheckboxesNoClass';

const FunctionalCheckbox = ({
  columnCount,
  columnWidth,
  rowHeight,
  width,
  items,
  labelKey,
  maxHeight,
  handleCheckboxClick,
  selectedItemArray
}) => (
  <AutoSizer disableWidth>
    {() => (
      <CheckboxesNoClass
        columnCount={columnCount}
        columnWidth={columnWidth}
        height={maxHeight}
        width={width}
        items={items}
        labelKey={labelKey}
        rowHeight={rowHeight}
        handleCheckboxClick={handleCheckboxClick}
        selectedItemArray={selectedItemArray}
      />
    )}
  </AutoSizer>
);

FunctionalCheckbox.propTypes = {
  columnWidth: PropTypes.number.isRequired,
  rowHeight: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  labelKey: PropTypes.string.isRequired,
  maxHeight: PropTypes.number.isRequired,
  handleCheckboxClick: PropTypes.func.isRequired,
  selectedItemArray: PropTypes.array.isRequired,
};

export default FunctionalCheckbox;
